import * as React from 'react';

import TabsSection from 'components/tabs/tabs-section/TabsSection';

import { __t, applyTranslations } from 'utils/language';
import {
  DELIVERABLE_TYPE_INSTAGRAM_POST,
  DELIVERABLE_TYPE_INSTAGRAM_REEL,
  DELIVERABLE_TYPE_INSTAGRAM_STORY,
  DELIVERABLE_TYPE_TIKTOK_VIDEO,
  DELIVERABLE_TYPE_ZALANDO_OUTFIT
} from 'utils/deliverables';

import type { ReportingDeliverableTypes } from '../../types';

import './campaign-report-tabs.scss';

applyTranslations(require('./campaign-report-tabs.i18n.json'));

type Props = {
  activeTab: ReportingDeliverableTypes,
  availableTabs: Array<ReportingDeliverableTypes>,
  enabledTabs: Array<ReportingDeliverableTypes>,
  onClick: (filterByPostType: ReportingDeliverableTypes) => void
};

const TABS = [
  {
    label: __t('campaign_report_tabs.ig_posts'),
    identifier: DELIVERABLE_TYPE_INSTAGRAM_POST,
    icon: {
      name: 'instagram-custom-fg',
      width: 24,
      height: 24,
      isDynamic: true
    }
  },
  {
    label: __t('campaign_report_tabs.ig_stories'),
    identifier: DELIVERABLE_TYPE_INSTAGRAM_STORY,
    icon: {
      name: 'story-custom-fg',
      width: 24,
      height: 24,
      isDynamic: true
    }
  },
  {
    label: __t('campaign_report_tabs.ig_reels'),
    identifier: DELIVERABLE_TYPE_INSTAGRAM_REEL,
    icon: {
      name: 'reel-custom-fg',
      width: 24,
      height: 24,
      isDynamic: true
    }
  },
  {
    label: __t('campaign_report_tabs.tiktok_videos'),
    identifier: DELIVERABLE_TYPE_TIKTOK_VIDEO,
    icon: {
      name: 'tiktok-custom-fg',
      width: 24,
      height: 24,
      isDynamic: true
    }
  },
  {
    label: __t('campaign_report_tabs.zalando_outfit'),
    identifier: DELIVERABLE_TYPE_ZALANDO_OUTFIT,
    icon: {
      name: 'hanger-custom-fg',
      width: 24,
      height: 24,
      isDynamic: true
    }
  }
];

const CampaignReportTabs = (
  {
    onClick,
    enabledTabs,
    availableTabs,
    activeTab
  }: Props
): JSX.Element => (
  <div className="campaign-report-tabs">
    <TabsSection
      withShadow
      items={
        TABS
          .filter(item => availableTabs.includes(item.identifier as ReportingDeliverableTypes))
          .map(item => {
            const isDisabled = !enabledTabs.includes(item.identifier as ReportingDeliverableTypes);

            return ({
              ...item,
              isDisabled,
              popover: isDisabled ? (
                <div className="campaign-report-tabs__popup">
                  {__t('campaign_report_tabs.no_content')}
                </div>
              ) : null
            });
          })
      }
      activeTab={activeTab}
      onClick={(tabId?: string | null) => onClick((tabId || activeTab) as ReportingDeliverableTypes)}
    />
  </div>
);

export default CampaignReportTabs;
